module.exports = __webpack_public_path__ + "img/HFIG-600-timedomain.5011895d.webp";